import {
    Button,
    Flex,
    Heading,
    Link,
    Box
} from '@chakra-ui/react';
import React, { useEffect, useRef, useState } from 'react';
import Swal from 'sweetalert2';
import DoencaService from "../../../main/services/DoencaService";
import { Link as ReactLink, useHistory } from "react-router-dom";
import VisualizarInfo from './VisualizarInfo';
import { useAuthProvider } from "../../../Context/AuthProvider";
import SemRegistros from '../../components/SemRegistros';
import { doencaFunc } from '../../../helpers/Funcionalidades';

const VisualizarDoenca = (props) => {

    document.title = 'MCA - Doenças - Visualizar'
    let history = useHistory()

    const { roleKeycloack } = useAuthProvider();
    const _IsMounted = useRef(false);
    const [doenca, setDoenca] = useState([])
    const [isUpdating] = useState(props.match.params.editar ? true : false)

    useEffect(() => {

        _IsMounted.current = true;
        fetchData();
        return () => {
            _IsMounted.current = false;
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    function fetchData() {
        DoencaService.getDoenca(props.match.params.id)
            .then(res => {
                setDoenca(res.data)
            }).catch((err) => {
                Swal.fire({
                    title: 'Atenção!',
                    'text': "Registro não encontrado",
                    icon: 'warning',
                    confirmButtonText: 'Fechar',
                    confirmButtonColor: '#169499'
                }).then(() => {
                    history.push("/doenca/lista");
                })
            })
    }

    function checkStatus(acao) {
        let updated;
        DoencaService.getDoenca(props.match.params.id)
            .then(res => {
                updated = res.data
                const acaoUp = updated.dataFim ? "reativar" : "inativar";
                if (acaoUp !== acao) {
                    Swal.fire({
                        title: 'Atenção',
                        text: updated.dataFim ?
                            "Este registro já está inativo. Deseja reativá-lo?" :
                            "Este registro está ativo. Deseja inativá-lo?",
                        icon: 'warning',
                        showCancelButton: true,
                        confirmButtonColor: '#169499',
                        cancelButtonColor: '#169499',
                        confirmButtonText: updated.dataFim ?
                            "Sim, quero reativar!" :
                            "Sim, quero inativar!",
                        cancelButtonText: 'Cancelar'
                    }).then((result) => {
                        if (result.isConfirmed) {
                            history.push("/doenca/alterar-vigencia/" + updated.id);
                        }
                    })
                } else {
                    history.push("/doenca/alterar-vigencia/" + updated.id);
                }
            })
    }

    return roleKeycloack && roleKeycloack.includes(doencaFunc.doencaVisualizar) ? (
        <Flex
            pt={"20px"}
            px={["5px", "30px"]}
            h="100%"
            flexDir="column"
            w="100%"
            maxW="2000px"
            overflow="auto"
            pb={["10px", "20px"]}
        >
            <Flex
                flexDir="row"
                justifyContent="space-between"
            >

                <Heading fontSize={'large'}>
                    Visualizar Doença
                </Heading>
                <Link as={ReactLink}
                    to="/doenca/lista"
                    _hover={{ textDecoration: "none" }}
                >
                    <Button colorScheme={"teal"} px={16}>
                        Voltar
                    </Button>
                </Link>
            </Flex>
            <Flex
                flexDir="column"
            >
                <Flex
                    mt="25px"
                    flexDir="column"
                    borderRadius="20px"
                    w="100%"
                    overflow="hidden"
                >
                    <VisualizarInfo
                        title="Descrição"
                        info={doenca.descricao || ""}
                        bgColor="#F9FAFB"
                    />
                    <VisualizarInfo
                        title="Dispensa Laudo Médico para Efeitos do QUF/MPRJ?"
                        info={
                            doenca.dispensaLaudo
                                ? (doenca.dispensaLaudo === "S" ? "Sim" : "Não")
                                : ""
                        }
                        bgColor="#FFFFFF"
                    />
                    <VisualizarInfo
                        title="Data Início"
                        info={new Date(doenca.dataInicio).toLocaleDateString("PT-br") || ""}
                        bgColor="#F9FAFB"
                    />
                    {
                        doenca.dataFim &&
                        (
                            <VisualizarInfo
                                title="Data Fim"
                                info={new Date(doenca.dataFim).toLocaleDateString("PT-br")}
                                bgColor="#FFFFFF"
                            />
                        )
                    }
                    {
                        doenca.justificativa &&
                        (
                            <VisualizarInfo
                                title={
                                    doenca.dataFim == null && doenca.justificativa == null
                                        ? "Justificativa"
                                        :
                                        (
                                            doenca.dataFim == null && doenca.justificativa != null
                                                ? "Justificativa da Reativação"
                                                : "Justificativa da Inativação"
                                        )
                                }
                                info={doenca.justificativa || ""}
                                bgColor={doenca.dataFim ? "#F9FAFB" : "#FFFFFF"}
                            />
                        )
                    }
                </Flex>

                <Flex mt={2} justifyContent="space-between">
                    <Flex></Flex>
                    <Flex flexDir={"row"}>
                        {doenca.dataFim ? (
                            <></>
                        ) : (
                            <Link
                                as={ReactLink}
                                to={"/doenca/editar/" + doenca.id} _hover={{ textDecoration: 'none' }}>
                                <Button
                                    mr={2}
                                    mt={4}
                                    colorScheme={"teal"}

                                    px={14}
                                    type="button">
                                    {isUpdating ? "Cancelar" : "Editar"}
                                </Button>
                            </Link>
                        )}

                        <Button
                            mt={4}
                            mr={2}
                            colorScheme={"teal"}
                            px={14}
                            data-acao={doenca.dataFim ? "reativar" : "inativar"}
                            onClick={(e) => { checkStatus(e.target.dataset.acao) }}
                            type="button">

                            {doenca.dataFim ? "Reativar" : "Inativar"}
                        </Button>

                    </Flex>
                </Flex>


            </Flex>
        </Flex>
    ) : (
        <Box mt={2}>
            <SemRegistros buttonVisible={true} half />
        </Box>
    );
}
export default VisualizarDoenca;